import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box, Divider, Grid } from '@mui/material';
import { httpGet, httpPost } from '../../HttpRequestHandling/httpRequestHandler';
import { toast } from 'react-toastify';
import { getDisplayName } from '../Common/Utilities';
import './vendormap.css';
import { isNewUi } from '../../redesign/uiMode';

export function VendorMapDialog(props) {
    return (
        <div>
            <Dialog
                maxWidth={'sm'}
                open={props.isOpen}
            >
                <DialogContent className="vendorMapEditor mappedFieldsWrapper" sx={{ padding: 2 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            m: 'auto',
                            minWidth: 500,
                            minHeight: 150
                        }}
                    >
                        {props.isOpen && <VandorMapDialogContent {...props} />}
                    </Box>
                </DialogContent>
            </Dialog>
        </div>);
}

function VandorMapDialogContent(props) {
    const [type, setType] = React.useState(props.editorType);
    const [invoiceUserStatuses, setInvoiceUserStatuses] = React.useState([]);
    const [selectedUserStatusId, setSelectedUserStatusId] = React.useState(props.invoiceUserStatusId || '');
    const [isStatusChanged, setIsStatusChanged] = React.useState(false);

    const userStatusDisplayName = React.useMemo(() => getDisplayName('User Status'), []);

    React.useEffect(() => {
        if (props.isOpen) {
            setType(props.editorType);
            setSelectedUserStatusId(props.invoiceUserStatusId || '');
            setIsStatusChanged(false);

            httpGet('api/setup/getInvoiceUserStatus')
                .then((response) => {
                    setInvoiceUserStatuses(response?.data?.record || []);
                })
                .catch(() => {
                    setInvoiceUserStatuses([]);
                });
        }
    }, [props.isOpen, props.editorType, props.invoiceUserStatusId]);

    const editorType_changehandler = (event) => {
        setType(event.target.value);
    };

    const userStatus_changeHandler = (event) => {
        setSelectedUserStatusId(event.target.value);
        setIsStatusChanged(true);
    };

    const handleSaveAndClose = async () => {
        props.info?.inProgress(true);
        try {
            const saveData = {
                vendorMappingId: props.vendorMappingId,
                modelDefId: props.modelDefId,
                invoiceUserStatusId: selectedUserStatusId ? parseInt(selectedUserStatusId, 10) : null
            };

            const response = await httpPost('api/invoicedocument/setinvoiceuserstatus', saveData);

            if (response.data.success) {
                toast.success(<div>User status updated successfully</div>);
                if (props.onCloseSuccess) {
                    props.onCloseSuccess();
                } else {
                    props.onClose();
                }
            } else {
                toast.error(<div>{response.data.message}</div>);
            }
        } catch (error) {
            const backendMsg = error?.response?.data?.errorMessage ||
                error?.response?.data?.message ||
                error?.message ||
                "Save failed";
            toast.error(<div>{`Error: ${backendMsg}`}</div>);
        } finally {
            props.info?.inProgress(false);
        }
    };

    // New UI (docs/ui_redesign/18-ux-review.md, R10): labels over fields, Continue as the action, and Cancel, which
    // leaves Vendor Mapping the way its own Close does (props.onCancel). Same state and handlers as below.
    if (isNewUi()) {
        return (
            <div className="apw2-vmp">
                <h2 className="apw2-vmp-t">{props.firstTime ? 'New invoice mapping' : 'Invoice mapping'}</h2>
                <p className="apw2-vmp-sub">How should APWorks read this vendor&rsquo;s invoices?</p>
                <div className="apw2-vmp-f">
                    <label htmlFor="apw2-vmp-id">Vendor identifier</label>
                    <input id="apw2-vmp-id" disabled value={props?.vendorIdentifier} type="text" />
                </div>
                {props.modelDefId !== 3 && (
                    <div className="apw2-vmp-f">
                        <span id="apw2-vmp-level">Level of detail</span>
                        <div className="apw2-seg2" role="radiogroup" aria-labelledby="apw2-vmp-level">
                            <label className={type === 'summary' ? 'on' : ''}><input type="radio" name="apw2VmpType" checked={type === 'summary'} value={'summary'} onChange={editorType_changehandler} />Summary</label>
                            <label className={type === 'detail' ? 'on' : ''}><input type="radio" name="apw2VmpType" checked={type === 'detail'} value={'detail'} onChange={editorType_changehandler} />Detail</label>
                        </div>
                    </div>
                )}
                <div className="apw2-vmp-f">
                    <label htmlFor="apw2-vmp-status">{userStatusDisplayName}</label>
                    <select id="apw2-vmp-status" value={selectedUserStatusId} onChange={userStatus_changeHandler}>
                        <option value="">Not set</option>
                        {invoiceUserStatuses.map((item) => (
                            <option key={item.invoiceUserStatusId} value={item.invoiceUserStatusId}>{item.userStatusCode}</option>
                        ))}
                    </select>
                </div>
                <div className="apw2-vmp-bar">
                    {props.onCancel ? <button type="button" className="apw2-btn" data-apw2-dismiss="true" onClick={props.onCancel}>Cancel</button> : null}
                    <button type="button" className="apw2-btn" disabled={!isStatusChanged} onClick={handleSaveAndClose}>Save &amp; Close</button>
                    <button type="button" className="apw2-btn primary" disabled={(type || '') === ''} onClick={() => { props.onClose(type, selectedUserStatusId || ''); }}>Continue</button>
                </div>
            </div>
        );
    }

    return (
        <>
            <h2 className='subHeader' style={{ marginLeft: '5px' }}>New Invoice Mapping</h2>
            <Divider className='subHeaderUnderLine' orientation="vertical" variant="middle" flexItem />
            <div style={{ minHeight: 200, paddingTop: 50 }}>
                <Grid container spacing={2} xs={12} item alignItems={'start'}>
                    <Grid item xs={4} container justifyContent={'end'}>
                        <label>Vendor Identifier:</label>
                    </Grid>
                    <Grid item xs={6}>
                        <input disabled value={props?.vendorIdentifier} type="text" />
                    </Grid>

                    {props.modelDefId !== 3 && <>
                        <Grid item xs={4} container justifyContent={'end'}>
                            <label>Level of Detail:</label>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <input
                                        type="radio"
                                        id='chkSummary'
                                        checked={type === 'summary'}
                                        value={'summary'}
                                        onChange={editorType_changehandler}
                                    /> <label className={'simpleLables'} htmlFor='chkSummary'>Summary</label>
                                </Grid>
                                <Grid item xs={6}>
                                    <input
                                        type="radio"
                                        id='chkDetail'
                                        checked={type === 'detail'}
                                        value={'detail'}
                                        onChange={editorType_changehandler}
                                    /> <label className={'simpleLables'} htmlFor='chkDetail'>Detail</label>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>}

                    <Grid item xs={4} container justifyContent={'end'}>
                        <label>{userStatusDisplayName}:</label>
                    </Grid>
                    <Grid item xs={6}>
                        <select
                            value={selectedUserStatusId}
                            onChange={userStatus_changeHandler}
                            style={{ width: '100%', padding: '2px' }}
                        >
                            <option value="">Select {userStatusDisplayName}</option>
                            {invoiceUserStatuses.map((item) => (
                                <option key={item.invoiceUserStatusId} value={item.invoiceUserStatusId}>
                                    {item.userStatusCode}
                                </option>
                            ))}
                        </select>
                    </Grid>
                </Grid>
            </div>

            <Grid container item justifyContent={'center'} spacing={2}>
                <Grid item>
                    <button
                        className="btn-blue"
                        disabled={(type || '') === ''}
                        onClick={() => { props.onClose(type, selectedUserStatusId || ''); }}
                    >
                        Continue
                    </button>
                </Grid>
                <Grid item>
                    <button className="btn-blue" disabled={!isStatusChanged} onClick={handleSaveAndClose}>Save & Close</button>
                </Grid>
            </Grid>
        </>
    );
}